<template>

    <modal @close="cancelEditBanner" class="banner-modal" hideFooter preventClose>
        <div class="td-edit-container">
            <div class="pagination">
                <div class="form-name">
                    <h3 class="td-h1 mb-md-4 mt-md-2">{{formTitle}}</h3>
                </div>
                <div class="step-description">
                    <div :class="['step', {'active': formStep === 1}]">
                        <h5 class="td-h3">Step 1</h5>
                        <p>Enter banner information.</p>
                    </div>
                    <div :class="['step', {'active': formStep === 2}]">
                        <h5 class="td-h3">Step 2</h5>
                        <p>Select Services.</p>
                    </div>
                </div>
                <div class="form-steps">
                    <div @click="goToStep(1)" :class="['form-step mt-0', {'active': formStep === 1}]"><span class="step-count">1</span><span>Details</span></div>
                    <div @click="goToStep(2)" :class="['form-step', {'active': formStep === 2}]"><span class="step-count">2</span><span>Services</span></div>
                </div>
            </div>
            <div class="edit-pages td-form">
                <form :class="['form-page td-form wide-form', {'active': formStep === 1}]">

                    <div class="td-banner danger dismissible" v-if="errorMessage">
                        <icon name="faTriangleExclamation" type="solid"></icon>
                        <p>{{ errorMessage }}</p>
                        <icon name="faXmark" type="solid" @click="errorMessage = ''"></icon>
                    </div>
                    <div class="td-banner info dismissible" v-if="infoMessage">
                        <icon name="faCircleExclamation" type="solid"></icon>
                        <p>{{ infoMessage }}</p>
                        <icon name="faXmark" type="solid" @click="infoMessage = ''"></icon>
                    </div>

                    <div class="inputs-column">

                        <div class="td-banner info" v-if="bannerType =='regional'">
                            <icon name="faCircleExclamation" type="solid"></icon>
                            <p>A Regional Banner Ad is covering one State/Province under up to <strong class="td-text-secondary">five</strong> <a href="#" class="td-link" @click.prevent="nextStep($event)">Service Categories.</a></p>
                            <p><strong>Price: </strong><span class="td-text-secondary">$600.00 per year.</span></p>
                        </div>
                        <div class="td-banner info dismissible" v-else>
                            <icon name="faCircleExclamation" type="solid"></icon>
                            <p>A National Banner Ad is covering the whole country under up to <strong class="td-text-secondary">five</strong> <a href="#" class="td-link" @click.prevent="nextStep($event)">Service Categories.</a></p>
                            <p><strong>Price: </strong><span class="td-text-secondary">$1,200.00 per year.</span></p>
                        </div>
                        <div class="my-2" v-if="isAdmin && !hasSubs">
                            <label class="td-label">Status:</label>
                            <select id="term" v-model="editBannerModel.status" required class="td-select">

                                <option :value="BannerStatus.Active">Active</option>
                                <option :value="BannerStatus.Inactive">Inactive</option>
                                <option :value="BannerStatus.PendingApproval">Pending Approval</option>
                            </select>
                        </div>
                        <div class="my-2">
                            <label class="td-label">Type:</label>
                            <select id="term" v-model="bannerType" required class="td-select" @change="bannerValidator.validate('regionCode');bannerValidator.validate('countryCode');selectType()">
                                <option value="" disabled selected>Select type</option>
                                <option value="regional">Regional</option>
                                <option value="national">National</option>
                            </select>
                        </div>
                        <div v-show="bannerType =='regional'">
                            <label class="td-label required">State/Prov:</label>
                            <select v-model="editBannerModel.regionCode" id="regionCode" name="regionCode" required
                                    :class="[{'error': bannerValidator.errors && bannerValidator.errors['regionCode']}, 'td-select']"
                                    @change="selectRegion();bannerValidator.validate('regionCode')">
                                <option value="" disabled selected>Select region</option>
                                <option v-for="region in selectableRegions" :value="region" :key="region">{{ region }}</option>
                            </select>
                            <error v-if="bannerValidator.errors && bannerValidator.errors['regionCode']" :error="bannerValidator.errors['regionCode']"></error>
                        </div>
                        <div v-show="bannerType !='regional'">
                            <label class="td-label required">Country:</label>
                            <select v-model="editBannerModel.countryCode" id="regionCode" name="countryCode" required
                                    :class="[{'error': bannerValidator.errors && bannerValidator.errors['countryCode']}, 'td-select']"
                                    @change="bannerValidator.validate('countryCode')">
                                <option value="" disabled selected>Select country</option>
                                <option v-for="country in selectableCountries" :value="country.code" :key="country">{{ country.name }}</option>
                            </select>
                            <error v-if="bannerValidator.errors && bannerValidator.errors['countryCode']" :error="bannerValidator.errors['countryCode']"></error>
                        </div>
                        <div class="my-2">
                            <label class="td-label">Website address:</label>
                            <input v-model="editBannerModel.websiteAddress" @input="bannerValidator.validate('website')"
                                   :class="[{'error': bannerValidator.errors && bannerValidator.errors['website']}, 'td-input']"
                                   type="text" placeholder="ex. https://mywebsite.com" />
                            <error v-if="bannerValidator.errors && bannerValidator.errors['website']" :error="bannerValidator.errors['website']"></error>
                        </div>

                        <div class="my-2">
                            <label class="td-label mb-2">Banner image:</label>
                            <div class="form-img" v-if="imageUrl">
                                <v-lazy-image :src="imageUrl" alt="Banner" width="480" height="60"></v-lazy-image>
                               
                            </div>
                            <error v-if="bannerValidator.errors && bannerValidator.errors['image']" :error="bannerValidator.errors['image']"></error>
                            <dropzone :account-id="accountId" @files-uploaded="filesUploaded" :remove-id="imageIdToRemove" @start-upload="startUpload" :is-banner="true"></dropzone>
                        </div>
                    </div>
                </form>
                <form :class="['form-page', 'wide-form', {'active': formStep === 2}]">
                    <div class="td-banner info" v-if="bannerType =='regional'">
                        <icon name="faCircleExclamation" type="solid"></icon>
                        <p>A Regional Banner Ad is covering one State/Province under up to <strong class="td-text-secondary">five</strong> Service Categories.</p>
                    </div>
                    <div class="td-banner info dismissible" v-else>
                        <icon name="faCircleExclamation" type="solid"></icon>
                        <p>A National Banner Ad is covering the whole country under up to <strong class="td-text-secondary">five</strong> Service Categories.</p>
                    </div>
                    <div class="td-banner danger dismissible" v-if="errorMessage">
                        <icon name="faTriangleExclamation" type="solid"></icon>
                        <p>{{ errorMessage }}</p>
                        <icon name="faXmark" type="solid" @click="errorMessage = ''"></icon>
                    </div>
                    <div class="inputs-column service-list" v-if="!isLoading">
                        <template v-for="(service, index) in allServices" :key="index">
                            <div :class="[isSelectedService(service) ? 'selected' : '', 'rounded', 'service-select', 'td-card', 'grey']"
                                 @click="handleServiceSelect(service)">
                                <icon v-if="isSelectedService(service)" name="faCheck" type="solid" class="mx-1"></icon>
                                <icon v-if="!isSelectedService(service)" name="faSquare" type="regular" class="mx-1"></icon>
                                <span>{{service.name}}</span>
                            </div>
                        </template>
                    </div>

                    <div v-else class="td-banner info border">
                        <icon name="faSpinner" type="solid" spin></icon>
                        <p>Please wait</p>
                    </div>
                </form>
                <div class="actions">
                    <div class="td-pagination-btns secondary mt-1">
                        <button :class="['secondary, previous', {'disabled': formStep === 1}]"
                                @click="previousStep($event)"
                                title="Back">
                            <icon name="faAngleLeft" type="solid" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', 'secondary', {'disabled': formStep === 2}]"
                                @click="nextStep($event)" title="Next">
                            <icon name="faAngleRight" type="solid" aria-hidden="true"></icon>
                        </button>
                    </div>
                    <div class="td-flex action-btns">
                        <button title="Cancel Banner Edit" class="td-btn secondary-outlined" @click="cancelEditBanner">Cancel</button>
                        <button :title="formTitle" class="td-btn btn secondary" @click="saveBanner">{{buttonTitle}}</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditBanner';
    export default script;</script>

<style lang="less">
    @import "./EditBanner.less";
</style>